// extracted by mini-css-extract-plugin
export default {"modalOverlay":"LC-z","modalContent":"MC-z","header":"NC-z","close":"OC-z"};